import React, { PropsWithChildren } from 'react';
import SubmitFormBanner from '../../../common/SubmitFormBanner';

import s from './MobileSubmitLayout.scss';

interface Props {
  preview: React.ReactNode;
}

const MobileSubmitLayout: React.FC<PropsWithChildren<Props>> = ({
  preview,
  children,
}) => (
  <>
    <SubmitFormBanner />
    <div className={s['root']}>
      {preview}
      <div className={s['form']}>{children}</div>
    </div>
  </>
);

MobileSubmitLayout.displayName = 'MobileSubmitLayout';

export default MobileSubmitLayout;
